import script from "./help-table.vue?vue&type=script&setup=true&lang=ts"
export * from "./help-table.vue?vue&type=script&setup=true&lang=ts"

import "./help-table.vue?vue&type=style&index=0&id=2128c396&lang=scss"

const __exports__ = script;

export default __exports__